<div class="row justify-content-center" [ngClass]="routeAnimationsElements">
  <div class="col-md-8">
    <mat-card>

      <div *ngIf="sinTramitePendiente; else templateConTramitePendiente">
        <h4>Seleccione las actividades a registrar de su empresa</h4>
        <div class="row justify-content-center" [ngClass]="routeAnimationsElements">

          <ng-container *ngFor="let actConTT of actividadesConTooltips; let i = index">
            <div class="col-3">
              <div class="row">
                <div class="col-2">
                  <mat-checkbox id="actCheck_{{actConTT.tipo_actividad}}" [checked]="actConTT.checked"
                    (change)="onCheckboxChange($event,actConTT.tipo_actividad)"></mat-checkbox>
                </div>
                <div class="col-10">
                  <mat-icon matTooltip={{actConTT.tooltip}}>
                    <img class="imgActividad" src="./assets/iconos/{{actConTT.nombre}}.jpg" alt="{{actConTT.nombre}}">
                  </mat-icon>
                </div>
              </div>
              <div class="row">
                <span>{{actConTT.nombre}}</span>
              </div>
            </div>
          </ng-container>

        </div>
        <div class="row">
          <mat-hint>
            <fa-icon icon="info-circle"></fa-icon>
            A continuación se le solicitará información asociada a cada actividad
            seleccionada
          </mat-hint>
        </div>
        <div class="row buttons d-flex justify-content-between pad" [ngClass]="routeAnimationsElements">
          <button type="reset" routerLink="/main/landing" mat-raised-button>
            {{ 'rpe.vista-usuario.volver' | translate }}
          </button>
          <button type="submit" mat-raised-button (click)="onSubmit()" color="primary">
            {{ 'rpe.vista-usuario.confirmar' | translate }}
          </button>
        </div>
      </div>

      <ng-template #templateConTramitePendiente>
        Usted tiene un trámite de registro de actividad pendiente, debe completarlo primero.
        <br>
        <div class="row buttons d-flex justify-content-between pad" [ngClass]="routeAnimationsElements">
          <button type="reset" routerLink="/main/landing" mat-raised-button>
            {{ 'rpe.vista-usuario.volver' | translate }}
          </button>
        </div>
      </ng-template>
    </mat-card>
  </div>
</div>